module.exports = __webpack_public_path__ + "src/assets/lt.12b1c0fd.png";